<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Process Start Time"
      imgName="circle">
      {{ process.startTimestamp | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      v-if="process.endTimestamp"
      name="Process End Time"
      imgName="circle">
      {{ process.endTimestamp | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="User"
      imgName="circle">
      {{ relatedUser(process.uid) }}
    </detail-item>
    <detail-item
      name="Group"
      imgName="circle">
      {{ relatedGroup(process.gid) }}
    </detail-item>
    <detail-item
      name="Pid"
      imgName="circle">
      {{ process.pid }}
    </detail-item>
    <detail-item
      v-if="process.ppid"
      name="Parent Process"
      imgName="circle">
      {{ relatedProcess(process.ppid) }}
    </detail-item>
    <detail-item
      v-if="process.args.length > 0"
      name="Process"
      imgName="circle">
      {{ process.args.join(' ') }}
    </detail-item>
    <detail-item
      v-else-if="process.path"
      name="Process"
      imgName="circle">
      {{ process.path }}
    </detail-item>
    <detail-item
      name="Name"
      imgName="circle">
      {{ process.name }}
    </detail-item>
    <alert-log-signing-info
      :signingInfo="process.signingInfo"
      :related="related">
    </alert-log-signing-info>
    <detail-item
      name="Process UUID"
      imgName="circle">
      {{ process.uuid }}
    </detail-item>
  </div>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import AlertLogSigningInfo from '@/components/alertlogs/AlertLogSigningInfo.vue';

export default {
  name: 'AlertLogProcess',
  mixins: [alertlog, gmt],
  components: {
    DetailItem,
    AlertLogSigningInfo,
  },
  props: {
    process: {
      type: Object,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defs: this.$typeDefs,
    };
  },
};
</script>
